/* global Promise */
import angular from 'angular';
import * as R from 'ramda';

export default function BulkResetProcessesDialogController(
  $rootScope,
  $q,
  alerts,
  ssDialogService,
  loaderService,
  praDataService
) {
  const vm = this;

  vm.hasData = false;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleBulkReset = _handleBulkReset;

  vm.handleSelectProcessChange = _handleSelectProcessChange;
  vm.handleSelectAll = _handleSelectAll;

  _activate();

  // //////// METHODS //////////

  function _activate() {  
    if (vm.processes.length > 0) {
      vm.hasData = true;
    }

    loaderService.showViewLoader = false;
  }

  function _handleCloseDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.bcp.bulkResetProcessesDialog);
  }

  function _handleSelectProcessChange() {
    const selectedIds = [];

    R.forEach((item) => {
      if (item.isSelected === true) {
        selectedIds.push(item.processId);
      }
    }, vm.processes);

    vm.resetIsSelected = selectedIds.length > 0;
    vm.selectAll = selectedIds.length === vm.processes.length;
  }
  
  function _handleSelectAll() {
    R.forEach((item) => {
      item.isSelected = vm.selectAll;
    }, vm.processes);
      
    vm.resetIsSelected = vm.selectAll;
  } 

  function _handleBulkReset() {
    loaderService.showViewLoader = true;
    const bulkResetProcessIds = [];

    // Find selections
    angular.forEach(vm.processes, (process) => {
      if (process && process.isSelected) {
        bulkResetProcessIds.push(process.assessmentProcessId);
      }
    });

    // Stop if no selections
    if (bulkResetProcessIds.length <= 0) {
      vm.isSelected = false;
      loaderService.showViewLoader = false;
      return Promise.resolve();
    }
    
    // Reset selected
    return praDataService.bulkResetAssessmentProcesses(vm.assessmentId, bulkResetProcessIds).then(() => {
      alerts.success('The Processes have been Reset successfully.');
      _handleCloseDialog();
      loaderService.showViewLoader = false;
      $rootScope.$broadcast('refreshPRAAssessments');
    },
    () => {
      alerts.error('There was an error while attempting to Reset the Processes.');
      loaderService.showViewLoader = false;
    });
  }
}

BulkResetProcessesDialogController.$inject = [
  '$rootScope',
  '$q',
  'alerts',
  'ssDialogService',
  'loaderService',
  'praDataService'
];
